import React, { useState, useEffect } from 'react';
import { adminAPI } from '../../services/api';
import toast from 'react-hot-toast';
import Modal from '../../components/common/Modal';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';

const SubjectManagement = () => {
  const [subjects, setSubjects] = useState([]);
  const [classes, setClasses] = useState([]);
  const [teachers, setTeachers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showSubjectModal, setShowSubjectModal] = useState(false);
  const [showAssignmentModal, setShowAssignmentModal] = useState(false);
  const [editingSubject, setEditingSubject] = useState(null);
  const [selectedSubject, setSelectedSubject] = useState(null);

  const subjectSchema = Yup.object().shape({
    subject_name: Yup.string().required('Subject name is required'),
    subject_code: Yup.string().required('Subject code is required'),
  });

  // const assignmentSchema = Yup.object().shape({
  //   class_id: Yup.number().required('Class is required'),
  //   teacher_email: Yup.number().required('Teacher is required'),
  // });


    const assignmentSchema = Yup.object().shape({
      class_id: Yup.string().required('Class is required'), // Changed from number to string
      teacher_email: Yup.string().required('Teacher is required'), // Changed from teacher_id to teacher_email
    });

  useEffect(() => {
    fetchData();
  }, []);


  // const fetchData = async () => {
  //   try {
  //     setLoading(true);
  //     const [subjectsRes, classesRes, staffRes] = await Promise.all([
  //       adminAPI.getSubjects(),
  //       adminAPI.getClasses(),
  //       adminAPI.getStaff(),
  //     ]);
      
  //     setSubjects(subjectsRes.data);
  //     setClasses(classesRes.data);
  //     setTeachers(staffRes.data.filter(s => s.staff_role === 'lead_four'));
  //   } catch (error) {
  //     toast.error('Failed to load data');
  //   } finally {
  //     setLoading(false);
  //   }
  // };



  const fetchData = async () => {
  try {
    setLoading(true);
    const [subjectsRes, classesRes, staffRes] = await Promise.all([
      adminAPI.getSubjectsWithAssignments(), // Changed from getSubjects()
      adminAPI.getClasses(),
      adminAPI.getStaff(),
    ]);
    
    setSubjects(subjectsRes.data);
    setClasses(classesRes.data);
    setTeachers(staffRes.data.filter(s => s.staff_role === 'lead_four'));
  } catch (error) {
    toast.error('Failed to load data');
  } finally {
    setLoading(false);
  }
};


  // const handleCreateSubject = async (values, { setSubmitting, resetForm }) => {
  //   try {
  //     if (editingSubject) {
  //       // Update subject logic here
  //       toast.success('Subject updated successfully');
  //     } else {
  //       await adminAPI.createSubject(values);
  //       toast.success('Subject created successfully');
  //     }
      
  //     setShowSubjectModal(false);
  //     resetForm();
  //     setEditingSubject(null);
  //     fetchData();
  //   } catch (error) {
  //     toast.error(error.response?.data?.detail || 'Operation failed');
  //   } finally {
  //     setSubmitting(false);
  //   }
  // };

  const handleCreateSubject = async (values, { setSubmitting, resetForm }) => {
  try {
    if (editingSubject) {
      // Update subject
      await adminAPI.updateSubject(editingSubject.id, values);
      toast.success('Subject updated successfully');
    } else {
      await adminAPI.createSubject(values);
      toast.success('Subject created successfully');
    }
    
    setShowSubjectModal(false);
    resetForm();
    setEditingSubject(null);
    fetchData();
  } catch (error) {
    toast.error(error.response?.data?.detail || 'Operation failed');
  } finally {
    setSubmitting(false);
  }
};

  const handleAssignToClass = async (values, { setSubmitting, resetForm }) => {
    try {
      await adminAPI.assignSubject({
        class_id: values.class_id,
        subject_id: selectedSubject.id,
        staff_email: values.teacher_email,
      });
      toast.success('Subject assigned to class successfully');
      setShowAssignmentModal(false);
      resetForm();
      fetchData();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Operation failed');
    } finally {
      setSubmitting(false);
    }
  };



  // const handleDeleteSubject = async (id) => {
  //   if (window.confirm('Are you sure you want to delete this subject?')) {
  //     try {
  //       // Delete subject logic here
  //       toast.success('Subject deleted successfully');
  //       fetchData();
  //     } catch (error) {
  //       toast.error('Failed to delete subject');
  //     }
  //   }
  // };


  const handleDeleteSubject = async (id) => {
  if (window.confirm('Are you sure you want to delete this subject?')) {
    try {
      await adminAPI.deleteSubject(id);
      toast.success('Subject deleted successfully');
      fetchData();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to delete subject');
    }
  }
};


//   const handleDeleteSubject = async (id) => {
//   if (window.confirm('Are you sure you want to delete this subject?')) {
//     try {
//       await adminAPI.deleteSubject(id);
//       toast.success('Subject deleted successfully');
//       fetchData();
//     } catch (error) {
//       toast.error(error.response?.data?.detail || 'Failed to delete subject');
//     }
//   }
// };



const handleRemoveAssignment = async (assignmentId) => { // Changed parameters
  if (window.confirm('Are you sure you want to remove this assignment?')) {
    try {
      await adminAPI.removeAssignment(assignmentId);
      toast.success('Assignment removed successfully');
      fetchData();
    } catch (error) {
      toast.error('Failed to remove assignment');
    }
  }
};
  // const handleRemoveAssignment = async (subjectId, classId) => {
  //   if (window.confirm('Are you sure you want to remove this assignment?')) {
  //     try {
  //       // Remove assignment logic here
  //       toast.success('Assignment removed successfully');
  //       fetchData();
  //     } catch (error) {
  //       toast.error('Failed to remove assignment');
  //     }
  //   }
  // };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">Subject Management</h1>
          <p className="text-gray-600">Manage subjects and assign to classes</p>
        </div>
        <button
          onClick={() => {
            setEditingSubject(null);
            setShowSubjectModal(true);
          }}
          className="btn-primary flex items-center"
        >
          <i className="fas fa-plus mr-2"></i> Add Subject
        </button>
      </div>

      {/* Quick Stats */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <div className="bg-white rounded-lg shadow p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-500">Total Subjects</p>
              <p className="text-2xl font-bold">{subjects.length}</p>
            </div>
            <div className="p-3 bg-primary-100 rounded-lg">
              <i className="fas fa-book text-primary-600 text-xl"></i>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-500">Active Teachers</p>
              <p className="text-2xl font-bold">{teachers.length}</p>
            </div>
            <div className="p-3 bg-green-100 rounded-lg">
              <i className="fas fa-chalkboard-teacher text-green-600 text-xl"></i>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-500">Class Assignments</p>
              <p className="text-2xl font-bold">
                {subjects.reduce((acc, subject) => acc + (subject.assignments?.length || 0), 0)}
              </p>
            </div>
            <div className="p-3 bg-yellow-100 rounded-lg">
              <i className="fas fa-tasks text-yellow-600 text-xl"></i>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-500">Available Classes</p>
              <p className="text-2xl font-bold">{classes.length}</p>
            </div>
            <div className="p-3 bg-purple-100 rounded-lg">
              <i className="fas fa-school text-purple-600 text-xl"></i>
            </div>
          </div>
        </div>
      </div>

      {/* Subjects Table */}
      <div className="bg-white rounded-lg shadow overflow-hidden">
        <div className="table-responsive">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Subject
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Code
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Assigned Classes
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Teachers
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {subjects.map((subject) => (
                <tr key={subject.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4">
                    <div className="flex items-center">
                      <div className="flex-shrink-0 h-10 w-10 bg-blue-100 rounded-full flex items-center justify-center">
                        <i className="fas fa-book text-blue-600"></i>
                      </div>
                      <div className="ml-4">
                        <div className="text-sm font-medium text-gray-900">
                          {subject.subject_name}
                        </div>
                        <div className="text-sm text-gray-500">
                          ID: {subject.id}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
                      {subject.subject_code || 'N/A'}
                    </span>
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex flex-wrap gap-1">
                      {subject.assignments?.length > 0 ? (
                        subject.assignments.map((assignment, index) => (
                          <span key={index} className="inline-flex items-center px-2 py-1 rounded text-xs bg-green-100 text-green-800">
                            {assignment.class_name}
                            <button
                              onClick={() => handleRemoveAssignment(assignment.id)}
                              className="ml-1 text-green-600 hover:text-green-800"
                            >
                              <i className="fas fa-times"></i>
                            </button>
                          </span>
                        ))
                      ) : (
                        <span className="text-sm text-gray-500">Not assigned</span>
                      )}
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="text-sm text-gray-900">
                      {subject.teachers?.join(', ') || 'No teacher'}
                    </div>
                  </td>
                  <td className="px-6 py-4 text-sm font-medium space-x-2">
                    <button
                      onClick={() => {
                        setEditingSubject(subject);
                        setShowSubjectModal(true);
                      }}
                      className="text-primary-600 hover:text-primary-900"
                    >
                      <i className="fas fa-edit"></i>
                    </button>
                    <button
                      onClick={() => handleDeleteSubject(subject.id)}
                      className="text-red-600 hover:text-red-900"
                    >
                      <i className="fas fa-trash"></i>
                    </button>
                    <button
                      onClick={() => {
                        setSelectedSubject(subject);
                        setShowAssignmentModal(true);
                      }}
                      className="text-green-600 hover:text-green-900"
                    >
                      <i className="fas fa-plus"></i> Assign
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {subjects.length === 0 && (
          <div className="text-center py-12">
            <i className="fas fa-book text-4xl text-gray-300 mb-4"></i>
            <p className="text-gray-500">No subjects created yet</p>
            <p className="text-sm text-gray-400 mt-1">Create your first subject to get started</p>
          </div>
        )}
      </div>

      {/* Create/Edit Subject Modal */}
      <Modal
        isOpen={showSubjectModal}
        onClose={() => {
          setShowSubjectModal(false);
          setEditingSubject(null);
        }}
        title={editingSubject ? 'Edit Subject' : 'Create New Subject'}
      >
        <Formik
          initialValues={{
            subject_name: editingSubject?.subject_name || '',
            subject_code: editingSubject?.subject_code || '',
          }}
          validationSchema={subjectSchema}

          onSubmit={handleCreateSubject}
        >
          {({ isSubmitting, errors, touched }) => (
            <Form className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Subject Name *
                </label>
                <Field
                  type="text"
                  name="subject_name"
                  className="input-field"
                  placeholder="e.g., Mathematics, English Language"
                />
                {errors.subject_name && touched.subject_name && (
                  <div className="text-red-500 text-sm mt-1">{errors.subject_name}</div>
                )}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Subject Code *
                </label>
                <Field
                  type="text"
                  name="subject_code"
                  className="input-field"
                  placeholder="e.g., MATH, ENG"
                />
                {errors.subject_code && touched.subject_code && (
                  <div className="text-red-500 text-sm mt-1">{errors.subject_code}</div>
                )}
              </div>

              <div className="flex justify-end space-x-3 pt-4">
                <button
                  type="button"
                  onClick={() => {
                    setShowSubjectModal(false);
                    setEditingSubject(null);
                  }}
                  className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="btn-primary px-4 py-2"
                >
                  {isSubmitting ? (
                    <>
                      <i className="fas fa-spinner fa-spin mr-2"></i>
                      Saving...
                    </>
                  ) : (
                    <>
                      <i className="fas fa-save mr-2"></i>
                      {editingSubject ? 'Update' : 'Create'}
                    </>
                  )}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal>

      {/* Assign Subject Modal */}
      <Modal
        isOpen={showAssignmentModal}
        onClose={() => {
          setShowAssignmentModal(false);
          setSelectedSubject(null);
        }}
        title={`Assign ${selectedSubject?.subject_name || 'Subject'} to Class`}
      >
        {/* <Formik
          initialValues={{
            class_id: '',
            teacher_email: '',
          }}
          validationSchema={assignmentSchema}
          onSubmit={handleAssignToClass}
        > */}
                    <Formik
                      key={selectedSubject?.id} // This forces reinitialization when subject changes
                      initialValues={{
                        class_id: '',
                        teacher_email: '',
                      }}
                      validationSchema={assignmentSchema}
                      onSubmit={handleAssignToClass}
                      enableReinitialize={true} // Important: allows form to reset when modal opens
                    >
          {({ isSubmitting, errors, touched }) => (
            <Form className="space-y-4">
              {selectedSubject && (
                <div className="bg-gray-50 p-4 rounded-lg mb-4">
                  <div className="flex items-center">
                    <div className="p-2 bg-blue-100 rounded-lg mr-3">
                      <i className="fas fa-book text-blue-600"></i>
                    </div>
                    <div>
                      <h4 className="font-medium text-gray-900">{selectedSubject.subject_name}</h4>
                      <p className="text-sm text-gray-500">Code: {selectedSubject.subject_code}</p>
                    </div>
                  </div>
                </div>
              )}

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Select Class *
                </label>
                <Field as="select" name="class_id" className="input-field">
                  <option value="">Choose a class</option>
                  {classes.map((cls) => (
                    <option key={cls.id} value={cls.id}>
                      {cls.class_name}
                    </option>
                  ))}
                </Field>
                {errors.class_id && touched.class_id && (
                  <div className="text-red-500 text-sm mt-1">{errors.class_id}</div>
                )}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Assign Teacher *
                </label>
                <Field as="select" name="teacher_email" className="input-field">
                  <option value="">Select a teacher</option>
                  {teachers.map((teacher) => (
                    <option key={teacher.staff_email} value={teacher.staff_email}>
                      {teacher.staff_name} ({teacher.staff_email})
                    </option>
                  ))}
                </Field>
                {errors.teacher_email && touched.teacher_email && (
                  <div className="text-red-500 text-sm mt-1">{errors.teacher_email}</div>
                )}
              </div>

              <div className="flex justify-end space-x-3 pt-4">
                <button
                  type="button"
                  onClick={() => {
                    setShowAssignmentModal(false);
                    setSelectedSubject(null);
                  }}
                  className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="btn-primary px-4 py-2"
                >
                  {isSubmitting ? (
                    <>
                      <i className="fas fa-spinner fa-spin mr-2"></i>
                      Assigning...
                    </>
                  ) : (
                    <>
                      <i className="fas fa-plus mr-2"></i>
                      Assign to Class
                    </>
                  )}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal>
    </div>
  );
};

export default SubjectManagement;